
export interface HealthEntityPlanDTO {
    healthentityplan: number | null;
    name: string | null;
    description?: string | null;

    healthentity: number | null;
    healthentityname: string | null;
}

export const defaultHealthEntityPlanDTO:HealthEntityPlanDTO = {
    healthentityplan: -1,
    name: '',
    description: '',
    healthentity: -1,
    healthentityname: ''
}
